import { LoadState } from "../../constants/enums";
import { ITotalRecords, ITotalRecordsState } from "./types";





export const defaultTotalRecords: ITotalRecords = {
    total_fee_amount: 0,
    total_paid_fee: 0,
    pending_fee: 0
   
}

export const defaultTotalRecordsState: ITotalRecordsState ={
     record: {
            data: [],
            loading: LoadState.NotLoaded,
            totalRecords: 0,
            error: null,
        },
        totalRecordsFee: {
            data: defaultTotalRecords,
            loading: LoadState.NotLoaded,
            totalRecords: 0,
            error: null,
        }
}